<app-loading *ngIf="contentReady"></app-loading>

<section class="bb-page">
  <div class="bb-page-shell">

    <!-- Header -->
    <header class="bb-page-header">
      <div class="bb-page-title-block">
        <span class="bb-eyebrow">{{ "Stock transfer" | transloco }}</span>
        <h2 class="bb-page-title">{{ "Stock transfer" | transloco }}</h2>
        <p class="bb-page-subtitle">{{ "Selected Items" | transloco }}</p>
      </div>
    </header>

    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="bb-card bb-p-20">
        <div class="bb-form-grid">

          @if(submitted && getMissingRequiredCount() > 0) {
            <div class="bb-form-alert bb-field-full" role="alert">
              {{ 'راجع بيانات التحويل قبل الاعتماد' | transloco }}
              <span>({{ getMissingRequiredCount() }} {{ 'حقول مطلوبة)' | transloco }}</span>
            </div>
          }

          <!-- From Warehouse -->
          <div class="bb-field">
            <label class="bb-label" for="from_warehouse_id">{{ "From Warehouse" | transloco }}</label>

            <div class="bb-select-wrap">
              <select
                class="bb-select"
                id="from_warehouse_id"
                formControlName="from_warehouse_id"
                (change)="loadStocks()"
                [ngClass]="{
                  'is-invalid': form.get('from_warehouse_id')?.touched && form.get('from_warehouse_id')?.invalid,
                  'is-valid': form.get('from_warehouse_id')?.touched && form.get('from_warehouse_id')?.valid
                }"
              >
                <option value="">{{ "warehouse" | transloco }}</option>
                <option *ngFor="let w of warehouses" [value]="w.id">
                  {{ w.name }}
                </option>
              </select>
            </div>

            @if(shouldShowError('from_warehouse_id')) {
              <div class="bb-field-error">
                {{ getErrorMessage('from_warehouse_id', ('From Warehouse' | transloco)) }}
              </div>
            }
          </div>

          <!-- To Warehouse -->
          <div class="bb-field">
            <label class="bb-label" for="to_warehouse_id">{{ "To Warehouse" | transloco }}</label>

            <div class="bb-select-wrap">
              <select
                class="bb-select"
                id="to_warehouse_id"
                formControlName="to_warehouse_id"
                [ngClass]="{
                  'is-invalid': form.get('to_warehouse_id')?.touched && form.get('to_warehouse_id')?.invalid,
                  'is-valid': form.get('to_warehouse_id')?.touched && form.get('to_warehouse_id')?.valid
                }"
              >
                <option value="">{{ "warehouse" | transloco }}</option>
                <option *ngFor="let w of warehouses" [value]="w.id">
                  {{ w.name }}
                </option>
              </select>
            </div>

            @if(shouldShowError('to_warehouse_id') && !shouldShowSameWarehouseError()) {
              <div class="bb-field-error">
                {{ getErrorMessage('to_warehouse_id', ('To Warehouse' | transloco)) }}
              </div>
            }

            @if(shouldShowSameWarehouseError()) {
              <div class="bb-field-error">{{ 'مخزن التحويل لازم يكون مختلف عن مخزن الاستلام' | transloco }}</div>
            }
          </div>

          <!-- Select Product -->
          <div class="bb-field bb-field-full" *ngIf="stocks.length > 0">
            <div class="bb-chip-select">
              <div class="bb-stock-transfer-select-tools">
                <label class="bb-label bb-chip-label">{{ 'select product' | transloco }}</label>

                <div class="bb-stock-transfer-select-actions">
                  <button
                    type="button"
                    class="bb-btn bb-btn-secondary"
                    (click)="toggleSelectAllProducts()"
                    [disabled]="getAvailableStocksCount() === 0"
                  >
                    {{ areAllAvailableProductsSelected() ? ('Deselect all' | transloco) : ('Select all' | transloco) }}
                  </button>

                  <button
                    type="button"
                    class="bb-btn bb-btn-ghost"
                    *ngIf="items.length > 0"
                    (click)="clearSelectedProducts()"
                  >
                    {{ 'Clear' | transloco }}
                  </button>

                  <span class="bb-stock-transfer-selected-count">
                    {{ items.length }} / {{ getAvailableStocksCount() }}
                  </span>
                </div>
              </div>

              <mat-form-field class="bb-chip-mat-field" appearance="outline">
                <mat-chip-grid #chipGrid class="bb-chip-grid-custom">
                  <mat-chip-row
                    *ngFor="let item of items.controls; let i = index"
                    (removed)="removeItem(i)"
                    class="bb-chip-item bb-chip-item-product"
                  >
                    {{ item.value.product.name_ar }}

                    <button matChipRemove type="button" class="bb-chip-remove-btn">
                      X
                    </button>
                  </mat-chip-row>

                  <input
                    matInput
                    class="bb-chip-input"
                    placeholder="{{ 'Search By product name' | transloco }}"
                    [value]="searchValue"
                    (input)="onSearchChange($event)"
                    [matAutocomplete]="auto"
                    [matChipInputFor]="chipGrid"
                  />
                </mat-chip-grid>
              </mat-form-field>
            </div>

            @if(shouldShowItemsError()) {
              <div class="bb-field-error">{{ 'select product' | transloco }} {{ 'مطلوب' | transloco }}</div>
            }
          </div>

          @if(shouldShowItemsError() && stocks.length === 0) {
            <div class="bb-field-error bb-field-full">
              {{ 'اختار مخزن المصدر أولا، أو لا توجد منتجات متاحة في المخزن المختار' | transloco }}
            </div>
          }

          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="addProduct($event)" class="bb-chip-autocomplete-panel">
            <mat-option *ngFor="let stock of filteredStocks" [value]="stock">
              {{ stock.name_ar }} –
              {{ 'quantity' | transloco }} :
              {{ stock.quantity }}
            </mat-option>
          </mat-autocomplete>

          <!-- Note -->
          <div class="bb-field bb-field-full">
            <label class="bb-label">{{ 'note' | transloco }}</label>

            <div class="bb-select-wrap">
              <select
                class="bb-select"
                (change)="applyQuickNote($event)"
                [ngClass]="{
                  'is-invalid': form.get('note')?.touched && form.get('note')?.invalid,
                  'is-valid': form.get('note')?.touched && form.get('note')?.valid
                }"
              >
                <option value="">{{ 'note' | transloco }}</option>
                <option value=" مرتجع">{{ 'مرتجع' | transloco }} </option>
                <option value="طلبات">{{ 'طلبات' | transloco }}</option>
                <option value=" تبديل">{{ 'تبديل' | transloco }} </option>
                <option value="نقص مخزون">{{ 'نقص مخزون' | transloco }}</option>
              </select>
            </div>
          </div>

          <!-- Selected Items -->
          <div class="bb-field bb-field-full" *ngIf="items.length > 0">
            <label class="bb-label">{{ 'Selected Items' | transloco }}</label>

            <div class="bb-table-scroll">
              <table class="bb-table table">
                <thead>
                  <tr>
                    <th>{{ "Product" | transloco }}</th>
                    <th>{{ 'quantity' | transloco }}</th>
                    <th class="bb-actions-th"></th>
                  </tr>
                </thead>

                <tbody formArrayName="items">
                  <tr *ngFor="let item of items.controls; let i = index" [formGroupName]="i">
                    <td>
                      <strong class="bb-text-navy bb-font-bold">
                        {{ item.value.product.name_ar }}
                      </strong>
                    </td>

                    <td>
                      <input
                        type="number"
                        class="bb-input"
                        formControlName="quantity"
                        (input)="onQuantityChange(i)"
                      />

                      @if(shouldShowQuantityError(i)) {
                        <div class="bb-field-error">{{ getQuantityErrorMessage(i) }}</div>
                      }

                      <small class="bb-field-hint">
                        {{ 'Available' | transloco }}: {{ item.value.product.quantity }}
                        |
                        {{ 'After transfer' | transloco }}:
                        {{ getRemainingQty(i) }}
                      </small>
                    </td>

                    <td class="bb-actions-td">
                      <button type="button" class="bb-icon-btn bb-icon-btn-danger" (click)="removeItem(i)">
                        ✖
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Submit -->
          <div class="bb-field bb-field-full bb-flex bb-justify-end">
            <button class="bb-btn bb-btn-primary bb-btn-wide" type="button" (click)="openPreview()">
              {{ 'Submit' | transloco }}
            </button>
          </div>

        </div>
      </div>
    </form>

  </div>
</section>
